import { Link } from 'react-router-dom'

export const TERMS_VERSION = '1.0'

export function TermsPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-3xl px-4 py-10">
        <div className="text-2xl font-semibold text-slate-900">Termos de Uso</div>
        <div className="mt-2 text-sm text-slate-500">Versão {TERMS_VERSION}</div>

        <div className="mt-8 space-y-5 rounded-2xl border border-slate-200 bg-white p-6 text-sm text-slate-700">
          <p>
            Este sistema é destinado ao uso corporativo para gestão de RH e cálculos trabalhistas.
            O usuário é responsável pela veracidade das informações inseridas e pela conferência dos
            resultados antes de qualquer providência legal/contábil.
          </p>
          <p>
            O acesso é pessoal e intransferível. É proibido compartilhar credenciais. Todas as ações
            relevantes podem ser registradas em logs para auditoria e segurança.
          </p>
          <p>
            O uso do sistema implica concordância com a Política de Privacidade e com este documento.
          </p>
        </div>

        <div className="mt-6 text-sm">
          <Link className="text-slate-900 underline" to="/login">
            Voltar
          </Link>
        </div>
      </div>
    </div>
  )
}

